import * as React from 'react';
import { History } from 'history';
import { FormattedMessage } from 'react-intl';
import { TERMS_PATH, PRIVACY_PATH } from '../../constants';

export default (props: { history: History }) => {
    const today = new Date();

    return (
        <footer>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-6 col-sm-12 col-md-6">
                        <ul>
                            <li key="footer1">
                                <a href={PRIVACY_PATH}><FormattedMessage id="common.footer.privacy" defaultMessage="Privacy Policy" /></a>
                            </li>
                            <li key="footer2">
                                <a href={TERMS_PATH}><FormattedMessage id="common.footer.terms" defaultMessage="Terms of Use" /></a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-lg-6 col-sm-12 col-md-6">
                        <FormattedMessage
                            id="common.footer.copyright"
                            defaultMessage="Copyright {year}"
                            values={{ year: today.getFullYear() }}>
                            {(txt) => (
                                <p>&copy; {txt}</p>
                            )}
                        </FormattedMessage>
                    </div>
                </div>
            </div>
        </footer>
    )
}



// WEBPACK FOOTER //
// ./src/client/shared/Footer.tsx